import { imageTemplates, ImageTemplate } from '@lib/components/Image/types'

export const buildPreviewUrl = (
  url: string,
  template: ImageTemplate
): string => {
  if (template === 'external') {
    return url
  }

  const params = imageTemplates[template]
  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}${params}&format=jpeg`
}

export const getImageConstructor = (): typeof Image | undefined => {
  if (typeof window === 'undefined') {
    return undefined
  }

  return window.Image
}
